import { apiClient } from '../api';
import type { ApiResponse } from '@/types/auth';
import type {
  AdminTransactionStats,
  ListTransactionsParams,
  TransactionItem,
  TransactionPagination,
} from '@/types/transactions';

class AdminTransactionService {
  getStats(period: '7d' | '30d' | 'all' = '30d') {
    return apiClient.get<ApiResponse<AdminTransactionStats>>('/admins/transactions/stats', {
      params: { period },
    });
  }

  list(params: ListTransactionsParams = {}) {
    return apiClient.get<
      ApiResponse<{ transactions: TransactionItem[]; pagination: TransactionPagination }>
    >('/admins/transactions', { params: params as Record<string, string | number> });
  }

  getById(id: number) {
    return apiClient.get<ApiResponse<{ transaction: TransactionItem }>>(`/admins/transactions/${id}`);
  }

  listForUser(userId: number, params: ListTransactionsParams = {}) {
    return apiClient.get<
      ApiResponse<{ transactions: TransactionItem[]; pagination: TransactionPagination }>
    >(`/admins/users/${userId}/transactions`, { params: params as Record<string, string | number> });
  }
}

export const adminTransactionService = new AdminTransactionService();
